import { buildPath, CommonPaths, commonSlugs } from './commonPaths';
import { CommunityPaths } from './communityPaths';
import { EventParams, EventsPaths } from './eventsPaths';
import { OrganizationParams } from './organizationsPaths';
import {
    CampaignIdPathParam,
    PathParam,
    SegmentIdPathParam,
    UserInfoIdPathParam
} from './pathsTypes';

const slugs = {
    ITEMS: {
        CAMPAIGNS: {
            PLURAL: 'campaigns',
            SINGLE: 'campaign'
        }
    }
};

const itemPaths = {
    CAMPAIGNS: slugs.ITEMS.CAMPAIGNS.PLURAL,
    CAMPAIGN(campaignId: CampaignIdPathParam) {
        return buildPath([slugs.ITEMS.CAMPAIGNS.SINGLE, campaignId]);
    }
};

type CampaignsSegmentParams = OrganizationParams & {
    segmentId: SegmentIdPathParam;
};
type CampaignParams = OrganizationParams &
    Partial<EventParams> & {
        campaignId: CampaignIdPathParam;
    };
type CampaignUserInfoParams = CampaignParams & {
    userInfoId: UserInfoIdPathParam;
};
type CampaignCreateParams = OrganizationParams &
    Partial<EventParams> & {
        options?: PathParam;
    };
type CampaignUpdateParams = OrganizationParams &
    Partial<EventParams> & {
        campaignId: CampaignIdPathParam;
    };

export const CampaignsPaths = {
    CAMPAIGNS({ organizationId, eventId }: OrganizationParams & Partial<EventParams>) {
        return buildPath([
            eventId
                ? EventsPaths.EVENT({ organizationId, eventId })
                : CommunityPaths.COMMUNITY({ organizationId }),
            itemPaths.CAMPAIGNS
        ]);
    },
    CAMPAIGNS_SEGMENT({ organizationId, segmentId }: CampaignsSegmentParams) {
        return buildPath([CampaignsPaths.CAMPAIGNS({ organizationId }), segmentId]);
    },
    CAMPAIGN({ organizationId, eventId, campaignId }: CampaignParams) {
        return buildPath([
            eventId
                ? EventsPaths.EVENT({ organizationId, eventId })
                : CommunityPaths.COMMUNITY({ organizationId }),
            itemPaths.CAMPAIGN(campaignId)
        ]);
    },
    CAMPAIGN_DASHBOARD(params: CampaignParams) {
        return buildPath([CampaignsPaths.CAMPAIGN(params), commonSlugs.SECTIONS.DASHBOARD]);
    },
    CAMPAIGN_PREVIEW({ userInfoId, ...params }: CampaignUserInfoParams) {
        return buildPath([
            CampaignsPaths.CAMPAIGN(params),
            commonSlugs.SECTIONS.PREVIEW,
            userInfoId
        ]);
    },
    CREATE(eventParams: CampaignCreateParams) {
        return CommonPaths.CREATE(CampaignsPaths.CAMPAIGNS(eventParams));
    },
    CREATE_TEMPLATE(eventParams: CampaignCreateParams) {
        return buildPath([CommonPaths.CREATE(CampaignsPaths.CAMPAIGNS(eventParams)), 'template']);
    },
    UPDATE(campaignParams: CampaignUpdateParams) {
        return CommonPaths.EDIT(CampaignsPaths.CAMPAIGN(campaignParams));
    }
};
